<template>
  <div>
    <template v-for="(value, index) in items">
      <template v-if="value._child">
        <el-submenu :index="value.menu_route" :key="index">
          <template slot="title">
            <i :class="value.menu_icon" v-if="value.menu_icon"></i>
            <span slot="title">{{value.menu_name}}</span>
          </template>
          <sidebar-items :items="value._child"></sidebar-items>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :index="value.menu_route" :key="index">
          <i :class="value.menu_icon" v-if="value.menu_icon"></i>
          <span slot="title">{{value.menu_name}}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItems',
  props: {
    items: {
      type: Array,
      default: []
    }
  }
}
</script>

<style lang="less" scoped>
  
</style>